export default {
  TOGGLE_LOADING (state) {
    state.loading = !state.loading
  },
  SET_USER (state, user) {
    state.user = user
  },
  SET_ACCESS_TOKEN (state, token) {
    state.accessToken = token
  },
  SET_REFRESH_TOKEN (state, token) {
    state.refreshToken = token
  },
  SET_EXPIRATION (state, expiration) {
    state.expiration = expiration
  },
  SET_LOADING_ACCESS_TOKEN (state, loading) {
    state.loadingAccessToken = loading
  },
  SET_LANGUAGE (state, language) {
    state.language = language
  },
  SET_CURRENCIES (state, currencies) {
    state.currencies = currencies
  },
  SET_TABLE_SCROLL_POSITION (state, position) {
    state.tableScrollPosition = position
  },
  SET_COOKIE_ACCEPT (state, value) {
    state.cookieAccept = value
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js